/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Rationing App API
 * This is to provide all the rationing related operations at rationing app tier.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shikha.raghava@amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Daily/Monthly/Yearly/Lifetime
 * @export
 */
export const Frequency = {
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  Yearly: 'YEARLY',
  Lifetime: 'LIFETIME',
} as const;
export type Frequency = (typeof Frequency)[keyof typeof Frequency];

export function FrequencyFromJSON(json: any): Frequency {
  return FrequencyFromJSONTyped(json, false);
}

export function FrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Frequency {
  return json as Frequency;
}

export function FrequencyToJSON(value?: Frequency | null): any {
  return value as any;
}
